module.exports = function() {
  return new Worker(__webpack_public_path__ + "ca7510581f0a2ada0b0f.worker.js");
};